import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/ui/select";
import { Bell, Circle, FileText, Gauge } from "lucide-react";
import { useNavigate } from "react-router-dom";

const DashboardHeader = () => {
  const navigate = useNavigate();
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        <PageHeader
          title="Asset Management Dashboard"
          subtitle=" Overview and quick actions for managing assets, work orders, and
            alerts."
        />
        <div className="flex items-center space-x-4">
          <Button
            onClick={() => navigate("/ax/service-order/landing/create")}
          >
            Create Work Order
          </Button>

          <Button
            variant="outline"
            onClick={() => navigate("/ax/asset-registry/assets/create/add")}
          >
            Add Asset
          </Button>
        </div>
      </div>
    </div>
  );
};
export default DashboardHeader;
